import { useState, useEffect } from "react";
import "./StillSocialProofBar.css";

/* ─── HELPERS ────────────────────────────────────────────────────────────────*/


function fitLabel(fit = "") {
  const f = fit.toLowerCase();
  if (f.includes("small")) return "Runs small — size up";
  if (f.includes("large")) return "Runs large — size down";
  return "True to size";
}

function Stars({ rating, size = 13 }) {
  return (
    <span className="spb-stars" style={{ fontSize: size }}>
      {[1,2,3,4,5].map(i => (
        <span key={i} className={i <= Math.round(rating) ? "spb-star" : "spb-star-empty"}>
          ★
        </span>
      ))}
    </span>
  );
}

/* ─── TICKER ─────────────────────────────────────────────────────────────────*/

function Ticker({ reviews }) {
  const items = reviews.filter(r => r.userName && r.rating);
  const doubled = [...items, ...items]; /* seamless loop */

  return (
    <div className="spb-ticker-wrap" aria-hidden="true">
      <div className="spb-ticker-track">
        {doubled.map((r, i) => (
          <span key={i} className="spb-tick">
            <span className="spb-tick-name">{r.userName}</span>
            <span className="spb-tick-sep">·</span>
            <span className="spb-tick-stars">{"★".repeat(r.rating)}</span>
            {r.fit && (
              <>
                <span className="spb-tick-sep">·</span>
                <span className="spb-tick-fit">{fitLabel(r.fit)}</span>
              </>
            )}
          </span>
        ))}
      </div>
    </div>
  );
}

/* ─── MAIN COMPONENT ─────────────────────────────────────────────────────────*/

function StillSocialProofBar() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    async function fetchReviews() {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/reviews`);
        if (!response.ok) {
          throw new Error("Failed to fetch reviews");
        }

        const data = await response.json();


        setReviews(data.reviews || []);
        setStats(data.stats || null);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    fetchReviews();
  }, []);

  return (
    <>
      <section className="spb-bar" aria-label="Customer reviews summary">

        {loading || !stats ? (
          <div className="spb-loading">Loading reviews…</div>
        ) : (
          <>
            {/* ── STATS ROW ───────────────────────────────────────── */}
            <div className="spb-stats">

              <div className="spb-stat">
                <span className="spb-stat-label">Rating</span>
                <div className="spb-stat-value">
                  <span className="spb-stat-num">{Number(stats.avgRating || 0).toFixed(1)}</span>
                  <Stars rating={stats.avgRating || 0}  size={12} />
                </div>
              </div>

              <div className="spb-divider-v" aria-hidden="true" />

              <div className="spb-stat">
                <span className="spb-stat-label">Reviews</span>
                <span className="spb-stat-num">{stats.count}</span>
              </div>

              <div className="spb-divider-v" aria-hidden="true" />

              <div className="spb-stat">
                <span className="spb-stat-label">Would recommend</span>
                <span className="spb-stat-num">{stats.pctRecommend}%</span>
              </div>

              <div className="spb-divider-v spb-divider-hide" aria-hidden="true" />

              <div className="spb-stat spb-stat-hide">
                <div className="spb-badge">
                  <span className="spb-badge-check">✓</span>
                  <span className="spb-badge-text">Verified purchases</span>
                </div>
              </div>

            </div>

            {/* ── HAIRLINE ────────────────────────────────────────── */}
            <div className="spb-divider-h" aria-hidden="true" />

            {/* ── TICKER ──────────────────────────────────────────── */}
            <Ticker reviews={reviews} />
          </>
        )}

      </section>
    </>
  );
}

export default StillSocialProofBar;
